import { gql } from "@apollo/client";


export const FETCH_DOCUMENTS_LIST = gql`
    query FetchDocumentsList {
        officialDocuments {
            id
            reference
            name
            category
            version_major
            version_minor
            groupName
            hoverTitle
            isActiveForCompany
            jurisdiction
            metadata
            amendsDocumentId
            rootContentNode {
                id
                type
                metadata
                sizeInTokens
                childNodes {
                    id
                    type
                    metadata
                    sizeInTokens
                    sizeInPages
                    associatedOfficialDocument {
                        id
                        reference
                        name
                    }
                }
                associatedOfficialDocument {
                    id
                    reference
                    name
                }
            }
        }
    }
`;